import ApprovalIcon from "@mui/icons-material/ApprovalRounded";
import CheckIcon from "@mui/icons-material/TaskAltRounded";
import { Avatar, Stack, Typography } from "@mui/material";
import { makeTintedBackgroundFromColor } from "@entrilia/shared/utilities/colorHelper";
import type { WorkflowTemplateActivity } from "../../../../../api/types/workflowTypes";

interface Props {
  activity: WorkflowTemplateActivity;
}

const WorkflowActivityIcon = ({ activity }: Props) => {
  const avatarSx = { width: 20, height: 20 };
  const iconSx = { width: 16, height: 16 };

  if (activity.isApprovalActivity) {
    return (
      <Avatar
        variant="rounded"
        sx={(t) => ({ ...avatarSx, bgcolor: makeTintedBackgroundFromColor(t, t.palette.primary.main) })}
      >
        <ApprovalIcon sx={{ ...iconSx, color: "primary.main" }} />
      </Avatar>
    );
  }

  return (
    <Avatar variant="rounded" sx={{ ...avatarSx, bgcolor: "action.disabledBackground" }}>
      <CheckIcon sx={{ ...iconSx, color: "action.disabled" }} />
    </Avatar>
  );
};

const WorkflowActivityTitle = ({ activity }: Props) => {
  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
      <WorkflowActivityIcon activity={activity} />
      <Typography
        id={activity.isApprovalActivity ? "workflow-diagram-approval-activity-title" : undefined}
        variant="subtitle1"
      >
        {activity.name}
      </Typography>
    </Stack>
  );
};

export default WorkflowActivityTitle;
